import React from 'react';
import { DriverFormData } from '../../types/driver';

const relationships = [
  'Spouse',
  'Parent',
  'Sibling',
  'Child',
  'Aunt / Uncle',
  'Cousin',
  'Friend',
  'Other',
];

interface NextOfKinStepProps {
  data: DriverFormData;
  updateData: (data: Partial<DriverFormData>) => void;
}

const NextOfKinStep: React.FC<NextOfKinStepProps> = ({ data, updateData }) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    updateData({ [name]: value });
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Next of Kin</h2>
      <p className="text-gray-600 mb-6">
        Provide details of a trusted person we can contact in case of an emergency.
        This information is kept strictly confidential.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Full Name *
          </label>
          <input
            type="text"
            name="nextOfKinName"
            value={data.nextOfKinName}
            onChange={handleChange}
            placeholder="Next of kin full name"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Phone Number *
          </label>
          <input
            type="tel"
            name="nextOfKinPhone"
            value={data.nextOfKinPhone}
            onChange={handleChange}
            placeholder="+234..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Relationship *
          </label>
          <select
            name="nextOfKinRelationship"
            value={data.nextOfKinRelationship}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          >
            <option value="">Select relationship</option>
            {relationships.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <div className="flex gap-3">
          <svg className="h-5 w-5 text-blue-400 shrink-0 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <div>
            <h3 className="text-sm font-medium text-blue-800">Why we collect this</h3>
            <p className="mt-1 text-sm text-blue-700">
              Next of kin information is required for emergency situations and is part of our
              safety and compliance policy. This information will never be shared with third parties
              and is stored securely in accordance with our privacy policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextOfKinStep;